import { apiClient, ExtendedAxiosResponse } from 'helpers/apiClient';
import { ChannelType } from 'models/ChannelType';
import { CustomerMasterSourceType } from 'models/swagger/customerMasterSourceType';

export const api = {
  filterAclUserPrivilegeResourceList: (
    url: string,
    privilegeType: string,
    resourceType: string,
    resourceList: string[],
    cpRefNo?: string,
    entityRefNo?: string
  ): Promise<ExtendedAxiosResponse> =>
    apiClient.post(
      `${url}/acl/filter-user-privilege-resources`,
      {
        privilegeType,
        resourceType,
        resourceList,
        ...(cpRefNo && { cpRefNo }),
        ...(entityRefNo && { entityRefNo }),
        forceCheck: true,
      },
      {
        params: {
          channel: ChannelType.MO2_CARE,
          customerMasterSource: CustomerMasterSourceType.O2POP,
        },
      }
    ),
};
